import React, {
  Fragment,
} from 'react';
import PropTypes from 'prop-types';
import Moudel from './components/Moudel'
import Appsort from './components/Appsort'
import Applabel from './components/Applabel'
import {
  Menu,
} from 'antd';
import { connect } from 'dva';
import { Link, Route, Redirect, Switch, BrowserRouter } from 'dva/router';

class applicationSetup extends React.Component {
  state = {
    current: 'mail'
  }

  isSelect = e => {
    this.setState({ current: e.key });
  };

  render() {
    const { current } = this.state;

    return <Fragment>
      <BrowserRouter>
        <div className='page-main-content'>
          <Menu onClick={this.isSelect} selectedKeys={current} mode="horizontal">
            <Menu.Item key="mail" >
              <Link to='/applicationSetup/moudel' >模块</Link>
            </Menu.Item>
            <Menu.Item key="app" >
              <Link to='/applicationSetup/appsort'>应用分类</Link>
            </Menu.Item>
            <Menu.Item key="alipay">
              <Link to='/applicationSetup/applabel'>应用标签</Link>
            </Menu.Item>
          </Menu>
        </div>

        <Switch>
          <Route path='/applicationSetup/moudel' component={Moudel} />
          <Route path='/applicationSetup/appsort' component={Appsort} />
          <Route path='/applicationSetup/applabel' component={Applabel} />
          <Redirect to='/applicationSetup/moudel' />
        </Switch>
      </BrowserRouter>
    </Fragment>;
  }
}

applicationSetup.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loginInfo: PropTypes.object,
};
export default connect(({ applicationSetup }) => applicationSetup)(applicationSetup);